import { lazy } from 'react'

export const ACLabel = lazy(() => import('./Label'))
export const ACDefaultButton = lazy(() => import('./Buttons/DefaultButton'))
export const ACSelectableButton = lazy(() => import('./Buttons/SelectableButton'))
export const ACImage = lazy(() => import('./Image'))
export const ACFeatureItem = lazy(() => import('./FeatureItem'))
export const ACScreenView = lazy(() => import('./Screen'))
